module.exports = __webpack_public_path__ + "img/fiftypercent.14000dae.png";